import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { PeerGroups } from "../types/app.interfaces";

export class PrecentileRankService extends BaseService {
  burgissUniverseRankIRR(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      MeasuresType.IRR,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseRankIRR",
      objRequest,
      this.APICONFIG.GETPERCENTRANK,
      FunctionGroup.PercentileRank
    );
  }
  burgissUniverseRankDPI(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      MeasuresType.DPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseRankDPI",
      objRequest,
      this.APICONFIG.GETPERCENTRANK,
      FunctionGroup.PercentileRank
    );
  }
  burgissUniverseRankTVPI(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      MeasuresType.TVPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseRankTVPI",
      objRequest,
      this.APICONFIG.GETPERCENTRANK,
      FunctionGroup.PercentileRank
    );
  }
  burgissUniverseRankRVPI(
    investId?: any[][],
    peerGroupId?: any,
    endDate?: any,
    returnConstituentCount?: any,
    dynamicParameter?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      investId,
      peerGroupId,
      endDate,
      returnConstituentCount,
      dynamicParameter,
      MeasuresType.RVPI,
      uniqueCellId
    );
    return super._pushOperation(
      "BurgissUniverseRankRVPI",
      objRequest,
      this.APICONFIG.GETPERCENTRANK,
      FunctionGroup.PercentileRank
    );
  }
  createPayload(
    investId: any[][] = null,
    peerGroupId: any = null,
    endDate: any = null,
    returnConstituentCount: any = false,
    dynamicParameter: any = null,
    measure: string = null,
    alias: string = null
  ) {
    const peerGroupsobject: PeerGroups = {
      peerGroupID: peerGroupId,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      measure: measure,
      comparisonDate: endDate,
      baseCurrency: false,
      adjustToMostRecent: true,
      currencyHedgesetId: "",
      alias: alias,
      fofLookThrough: false,
      useReceivedDate: false,
      dynamicParameter: dynamicParameter,
      returnConstituentCount: returnConstituentCount,
      numberOfFunds: null,
    };
    return peerGroupsobject;
  }
}
